module.exports = __webpack_public_path__ + "img/空白（订切口图）.27ee0ee7.jpg";